import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clone } from 'lodash-es';
import React from 'react';
import { Stack } from '@mui/material';
import Renderer, { getData, } from '../Renderer';
import BackgroundImage from './BackgroundImage';
import PlaceHolder from '../../portal/common/PlaceHolder';
const RowLayout = ({ items, spacing, limitToPageWidth, height, backgroundImage, opacity, data, context, editData, configId, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
config, }) => {
    const canAdd = editData && editData.actions && editData.actions.canEdit(configId);
    const isEmpty = editData && items.length === 0;
    return (_jsx(BackgroundImage, { backgroundImage: backgroundImage, opacity: opacity, children: _jsxs(Stack, { direction: "column", spacing: spacing, sx: {
                ...(limitToPageWidth && {
                    maxWidth: 1200,
                    marginX: 'auto',
                    width: '100%',
                }),
                ...(height && { height }),
            }, children: [items.map((itemId, index) => {
                    // its done this way to get the key in the right place...
                    if (canAdd) {
                        return (_jsxs(React.Fragment, { children: [_jsx(editData.DropTarget, { dropId: `${configId}@${index}`, editData: editData }), _jsx(Renderer, { configId: itemId, data: data, context: context, editData: editData })] }, itemId));
                    }
                    return (_jsx(Renderer, { configId: itemId, data: data, context: context, editData: editData }, itemId));
                }), canAdd && (_jsx(editData.DropTarget, { dropId: `${configId}@${items.length}`, editData: editData, hoverToOpen: !isEmpty, children: isEmpty ? (_jsx(PlaceHolder, { placeHolderName: "Configure Row Layout" })) : undefined }))] }) }));
};
RowLayout.getData = ({ items, backgroundImage, data, context, editData, }, store) => (Promise.allSettled([
    BackgroundImage.getData({ backgroundImage, context }, store),
    ...items.map((itemId) => (getData({
        configId: itemId,
        data,
        context,
        editData,
    }, store))),
]));
RowLayout.defaultProps = {
    height: undefined,
};
const meta = {
    group: 'layouts',
    name: 'Row Layout',
    description: 'Displays a stack of one or more components stacked vertically.',
    props: [
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'spacing',
            name: 'Space Between Rows',
            type: 'number',
            min: -20,
            max: 20,
            description: 'Amount of space between items in the stack.',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
        {
            key: 'backgroundImage',
            name: 'Background Image',
            type: 'backgroundImage',
            description: 'Add a background image to the stack.',
        },
        {
            key: 'opacity',
            name: 'Opacity',
            type: 'opacity',
            description: 'Change the Opacity of background.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'RowLayout',
        editProps: {
            canAdd: true,
            canRemove: true,
        },
        props: {
            items: [],
            backgroundColor: '#00ff00',
            opacity: '1',
            limitToPageWidth: true,
            verticalPadding: 1,
            horizontalPadding: 1,
        },
    },
    getChildren: (config) => (config.props.items),
    actions: (componentConfig, addComponentDialog) => ([
        ['Add Item', () => {
                console.log('Handle add item');
                // @todo - this should be handled at a higher level and/or in the list widget itself.
                const addHandler = ((key) => {
                    // @ts-expect-error - need to update this code
                    const addComponent = components[key];
                    componentConfig.props.items = [
                        ...componentConfig.props.items,
                        clone(addComponent.meta.defaultConfig),
                    ];
                });
                addComponentDialog(addHandler);
            }],
    ]),
};
RowLayout.meta = meta;
export default RowLayout;
//# sourceMappingURL=RowLayout.js.map